import Image from '../Image/Image'
import { ProductAssetVideoType } from './ProductAssets.types'

type videoType = { classname: string; video: ProductAssetVideoType }

export const ProductVideo = ({ classname, video }: videoType) => {
  const manageUrl = (url) => {
    if (url.includes('vimeo')) {
      // Look for a string with 'vimeo', then whatever, then a
      // forward slash and a group of digits.
      const match = /vimeo.*\/(\d+)/i.exec(url)
      // If the match isn't null (i.e. it matched)
      if (match) {
        // The grouped/matched digits from the regex
        return `https://player.vimeo.com/video/${match[1]}`
      }
    }
    if (url.includes('youtube')) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
      const match = url.match(regExp)
      return match && match[2].length === 11
        ? `https://www.youtube.com/embed/${match[2]}`
        : undefined
    }
    return ''
  }
  return (
    <div className={classname}>
      <picture>
        <Image src={video.srcImage} alt={video.alt} />
      </picture>
      <iframe
        title='title'
        src={`${manageUrl(
          video.srcVideo,
        )}?autoplay=1&loop=1&autopause=0&color=ffffff&title=0&controls=0&muted=1&byline=0&portrait=0`}
        width='640'
        height='360'
        allow='autoplay; fullscreen; picture-in-picture'
        allowFullScreen
      />
    </div>
  )
}
